import { configureStore } from '@reduxjs/toolkit'

import { clipboardListener, clipboardReducer } from './clipboard'
import { galleryReducer } from './gallery'
import { modalReducer } from './modal'
import { toastReducer } from './toast'
import { userListener, userReducer } from './user'
import { viewListener, viewReducer } from './view'

export const makeStore = () =>
  configureStore({
    middleware: (getDefault) =>
      getDefault({
        serializableCheck: {
          ignoredActions: [
            'modal/open',
            'toast/add',
            'persist/PERSIST',
            'persist/REHYDRATE',
            'persist/REGISTER',
            'persist/PAUSE',
            'persist/FLUSH',
            'persist/PURGE',
          ],
          ignoredPaths: ['modal.stack', 'toast.toasts'],
        },
      }).prepend(userListener.middleware, clipboardListener.middleware, viewListener.middleware),
    reducer: {
      clipboard: clipboardReducer,
      gallery: galleryReducer,
      modal: modalReducer,
      toast: toastReducer,
      user: userReducer,
      view: viewReducer,
    },
  })

export type ReduxStoreType = ReturnType<typeof makeStore>
export type ReduxRootState = ReturnType<ReduxStoreType['getState']>
export type ReduxDispatch = ReduxStoreType['dispatch']
